import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

import { ExampleFeedbackForm } from '../components/example-feedback-form.tsx'
import { Panel } from '../design-system/panel.tsx'

export const Route = createFileRoute('/example/feedback')({
  component: ExampleFeedbackPage
})

/**
 * ExampleFeedbackPage — the worked example of a routed screen.
 *
 * A `Panel` holding a form, which is the shape every mutating screen takes.
 *
 * @returns The example surface.
 */
function ExampleFeedbackPage(): JSX.Element {
  return (
    <Panel
      data-testid="example-feedback-page"
      title="Example form"
      description="Copy this page. Every mutating screen is a Zod schema plus react-hook-form."
    >
      <ExampleFeedbackForm />
    </Panel>
  )
}
